import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator/index';
import { withStyles, Chip } from '@material-ui/core';
import { NewReleases as InformationIcon, Build as ModificationIcon, AddCircle as CreationIcon, Cancel as SuppressionIcon } from '@material-ui/icons';

class LogChipType extends PureComponent {
    static propTypes = {
        type: PropTypes.string.isRequired,
        classes: PropTypes.object.isRequired
    };

    getDateFromType = () => {
        const { classes, type } = this.props;
        switch (type) {
            case 'modification':
                return {
                    icon: <ModificationIcon className={classes.chipIcon} />,
                    label: Translator.translate('logging.type.modification')
                };
            case 'information':
                return {
                    icon: <InformationIcon className={classes.chipIcon} />,
                    label: Translator.translate('logging.type.information')
                };
            case 'creation':
                return {
                    icon: <CreationIcon className={classes.chipIcon} />,
                    label: Translator.translate('logging.type.creation')
                };
            case 'suppression':
                return {
                    icon: <SuppressionIcon className={classes.chipIcon} />,
                    label: Translator.translate('logging.type.suppression')
                };
            default:
                return {
                    icon: null,
                    label: ''
                };
        }
    };

    render() {
        const { classes, type } = this.props;
        const typeObject = this.getDateFromType();
        return <Chip size="small" icon={typeObject.icon} label={typeObject.label} className={classes[type]} />;
    }
}

const styles = theme => ({
    chipIcon: {
        color: theme.palette.common.white
    },
    modification: {
        color: theme.palette.common.white,
        background: theme.palette.warning.dark
    },
    information: {
        color: theme.palette.common.white,
        background: theme.palette.warning.main
    },
    suppression: {
        color: theme.palette.common.white,
        background: theme.palette.error.main
    },
    creation: {
        color: theme.palette.common.white,
        background: theme.palette.success.main
    }
});

export default withStyles(styles, { withTheme: true })(LogChipType);



// WEBPACK FOOTER //
// ./data/components/LogChipType.js